<template>
  <div class="container">
    <img src="../assets/img/middle-pic.png"/>
  </div>
</template>

<script>
export default {
  name: 'MiddleBanner'
}
</script>

<style scoped>
  .container {
    width: 1180px;
    display: flex;
    align-items: center;
  }

  .container img {
    width: 1180px;
    height: 130px;
  }
</style>
